// extracted by mini-css-extract-plugin
module.exports = {"section":"blog-post-module--section--3lI_D"};